import React from "react";
import { Target, Rocket, Shield, TrendingUp, Sparkles } from "lucide-react";
import "./GoalMission.css";

const GoalMission = () => {
  return (
    <section className="goal-mission">
      <div className="goal-mission-container">
        {/* Background Decorations */}
        <div className="goal-mission-decoration"></div>
        <div className="goal-mission-decoration-2"></div>

        {/* Badge */}
        <div className="goal-mission-badge">
          <Sparkles size={12} className="goal-mission-badge-icon" />
          <span>Goal & Mission</span>
        </div>

        {/* Main Content */}
        <div className="goal-mission-content">
          <div className="goal-mission-icon-wrapper">
            <Target size={28} />
          </div>
          
          <p className="goal-mission-description">
            Our goal is to make travel simple, affordable, and dependable for everyone. 
            Our mission is to provide comfortable rides with exceptional service standards, 
            enabling passengers to travel with peace of mind.
          </p>
          
          <div className="goal-mission-divider"></div>

          <p className="goal-mission-description secondary">
            We aim to expand our services across Gujarat while maintaining the highest 
            levels of safety, transparency, and professionalism.
          </p>

          {/* Mission Points */}
          <div className="goal-mission-points">
            <div className="goal-mission-point">
              <div className="goal-mission-point-icon">
                <Shield size={15} />
              </div>
              <div className="goal-mission-point-content">
                <h4>Safety First</h4>
                <p>Highest safety standards</p>
              </div>
            </div>
            <div className="goal-mission-point">
              <div className="goal-mission-point-icon">
                <Rocket size={15} />
              </div>
              <div className="goal-mission-point-content">
                <h4>Growth & Expansion</h4>
                <p>Expanding across Gujarat</p>
              </div>
            </div>
            <div className="goal-mission-point">
              <div className="goal-mission-point-icon">
                <TrendingUp size={15} />
              </div>
              <div className="goal-mission-point-content">
                <h4>Transparency</h4>
                <p>Clear and honest service</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GoalMission;